import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

type InputProps = {
    onClick: () => void;
};

export default function FreshStartButton({ ...props }: InputProps) {
    const { t } = useTranslation();

    return (
        <div className="flex justify-center">
            <Button
                type="button"
                aria-label={t("accessibility.phonenumber.login.validate_password.fresh_start")}
                variant={"link"}
                size={"link"}
                className="font-bold h-auto"
                onClick={props.onClick}
            >
                {t("phonenumber_login_password_associated.fresh_start_message")}
            </Button>
        </div>
    );
}
